// ==================================================
// MARKETING: Edit "For Agents" page content here
// ==================================================

export const agentsHero = {
  headline: 'Empower Your Real Estate Business',
  subheadline: 'Help clients make confident decisions with AI-powered insights',
  ctaText: 'Try PropertyForecast',
  ctaLink: 'https://propertyforecast.co/?ref=hf',
  image: '/images/agents-placeholder.png',
}

export const agentsFeatures = [
  {
    title: 'Win More Listings',
    description: 'Show sellers accurate market forecasts to win their trust',
    icon: '🏆',
  },
  {
    title: 'Close Faster',
    description: 'Help buyers make faster decisions with data-backed insights',
    icon: '⚡',
  },
  {
    title: 'Build Trust',
    description: 'Provide professional insights that set you apart',
    icon: '🤝',
  },
]

export const agentsCTA = {
  headline: 'Ready to level up your business?',
  subheadline: 'Join top-performing agents using PropertyForecast',
  ctaText: 'Get Started',
  ctaLink: 'https://propertyforecast.co/?ref=hf',
}
